import { render, staticRenderFns } from "./PageCards.vue?vue&type=template&id=0509b5ee&scoped=true&"
import script from "./PageCards.vue?vue&type=script&lang=js&"
export * from "./PageCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509b5ee",
  null
  
)

export default component.exports